export default "__VITE_ASSET__COAGQIJO__"